(function () {
  'use strict';

  var englishCopy = 'GETTMI and our partners use cookies for analytics, ads, and to improve your experience.';

  function applyGettmiConsentCopy() {
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner || banner.dataset.gettmiConsentCopy === 'ready') return Boolean(banner);

    var title = banner.querySelector('#shopify-pc__banner__body-title');
    var policyLink = banner.querySelector('#shopify-pc__banner__body-policy-link');
    var manageButton = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    var acceptButton = banner.querySelector('#shopify-pc__banner__btn-accept');
    var declineButton = banner.querySelector('#shopify-pc__banner__btn-decline');
    var isEnglish = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;

    if (title) title.textContent = 'Cookie choices';

    if (isEnglish && policyLink && policyLink.parentNode) {
      Array.prototype.slice.call(policyLink.parentNode.childNodes).forEach(function (node) {
        if (node !== policyLink) node.remove();
      });
      policyLink.parentNode.insertBefore(document.createTextNode(englishCopy + ' '), policyLink);
      policyLink.textContent = 'See Cookie Policy';
      policyLink.setAttribute('href', '/pages/cookie-policy');
      policyLink.setAttribute('target', '_self');

      if (manageButton) manageButton.textContent = 'Change Settings';
      if (acceptButton) acceptButton.textContent = 'Accept';
      if (declineButton) declineButton.textContent = 'Decline non-essential';
    }

    banner.dataset.gettmiConsentCopy = 'ready';
    return true;
  }

  function initialiseGettmiConsentPresentation() {
    if (applyGettmiConsentCopy()) return;

    var observer = new MutationObserver(function () {
      if (applyGettmiConsentCopy()) observer.disconnect();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseGettmiConsentPresentation, { once: true });
  } else {
    initialiseGettmiConsentPresentation();
  }
})();
